const hasApplePay = (): boolean => {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return !!(window as any).ApplePaySession?.canMakePayment();
};

export { hasApplePay };
